module.exports = __webpack_public_path__ + "img/logo23.70fe230a.jpg";